<template>
    <v-dialog v-model="abrirModal" fullscreen persistent :scrollable="false">
        <v-card>
            <v-card-title class="bg-title-card"> 
                <span class="white--text headline" v-html="'Información del Producto'"></span>
                <v-spacer></v-spacer>
                <v-icon dark @click="cerrarModal()">close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-stepper v-model="elemento" class="removeBorder" vertical>
                    <!-- Seguro Vehículo -->
                    <template
                        v-if="!_.isUndefined(objForm.objProducto.idSeguro) ? parametros.idSeguroVehiculo == parseInt(objForm.objProducto.idSeguro) : false">
                        <v-stepper-step :complete="elemento > 1" step="1">Datos Generales</v-stepper-step>
                        <tab-datos-generales :listGeneral="listGeneral" :objForm="objForm.objProducto" :cargar="cargar"
                            :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 2" step="2">Beneficios Complementario</v-stepper-step>
                        <tab-beneficios-complementarios :cargar="elemento == 2 ? true : false"
                            :listGeneral="listGeneral" :objForm="objForm.objBeneficios" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 3" step="3">Correos de las Compañias de Seguro
                        </v-stepper-step>
                        <tab-correos :cargar="elemento == 3 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objCorreos" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 4" step="4">Documentos del Producto</v-stepper-step>
                        <tab-documentos :cargar="elemento == 4 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objDocumentos" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 5" step="5">Condiciones del Producto</v-stepper-step>
                        <tab-condiciones :cargar="elemento == 5 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objCondiciones" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 6" step="6">Coberturas Adicionales</v-stepper-step>
                        <tab-coberturas-adicionales :cargar="elemento == 6 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objCoberturas" :parametros="parametros" />
                    </template>

                    <!-- Otros Seguro -->
                    <template
                        v-else-if="_.isUndefined(objForm.objProducto.idSeguro) ? true : parametros.idSeguroVehiculo != parseInt(objForm.objProducto.idSeguro)">
                        <v-stepper-step :complete="elemento > 1" step="1">Datos Generales</v-stepper-step>
                        <tab-datos-generales :listGeneral="listGeneral" :objForm="objForm.objProducto" :cargar="cargar"
                            :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 2" step="2">Beneficios Complementario</v-stepper-step>
                        <tab-beneficios-complementarios :cargar="elemento == 2 ? true : false"
                            :listGeneral="listGeneral" :objForm="objForm.objBeneficios" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 3" step="3">Correos de las Compañias de Seguro
                        </v-stepper-step>
                        <tab-correos :cargar="elemento == 3 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objCorreos" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 4" step="4">Documentos del Producto</v-stepper-step>
                        <tab-documentos :cargar="elemento == 4 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objDocumentos" :parametros="parametros" />

                        <v-stepper-step :complete="elemento > 5" step="5">Condiciones del Producto</v-stepper-step>
                        <tab-condiciones :cargar="elemento == 5 ? true : false" :listGeneral="listGeneral"
                            :objForm="objForm.objCondiciones" :parametros="parametros" />
                    </template>
                </v-stepper>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props:{
            abrirModal:{type: Boolean, default: false},
            objeto:{type: Object, default: {}},
            listGeneral:{type: Object, default: {}},
            parametros:{type: Object, default: {}},
        },
        inject: ['onListar', 'cerrarModal'],
        components: {
            tabDatosGenerales:() => import('./DatosGeneralesComponent.vue'),
            tabCorreos:() => import('./DatosCorreoComponent.vue'),
            tabBeneficiosComplementarios:() => import('./BeneficiosComplementariosComponent.vue'),
            tabDocumentos: () => import('./DocumentacionComponent.vue'),
            tabCondiciones: () => import('./CondicionesComponent.vue'),
            tabCoberturasAdicionales: () => import('./CoberturasAdicionalesComponent.vue')
        },
        data() {
            return {
                elemento: 1,
                cargar: true,
                objForm: {
                    objProducto: {},
                    objCorreos: {},
                    objBeneficios: {},
                    objDocumentos: {},
                    objCondiciones: {},
                    objCoberturas: {}
                }
            }
        },
        watch: {
            abrirModal(val) {
                this.cargar = false;
                this.objForm.objProducto = {};
                if (val) {
                    this.elemento = 1;
                    this.objForm.objProducto = _.cloneDeep(this.objeto);
                    this.cargar = true;
                }
            }
        },
        methods: {
            next() {
                switch (++this.elemento) {
                    case 2:
                        var keys = ['idAseguradora', 'idSeguro', 'idPoliza', 'idProducto'];
                        this.objForm.objBeneficios = _.merge({}, this.getDatos(keys, this.objForm.objProducto), { 'idEstado': _.toString(this.parametros.idEstadoDefault) });
                        break;
                    case 3:
                        this.objForm.objCorreos = { 'idProducto': this.objForm.objProducto.idProducto, 'idEstado': _.toString(this.parametros.idEstadoDefault)};
                        break;
                    case 4:
                        var keys = ['idVehiCredi', 'idProducto'];
                        this.objForm.objDocumentos = _.merge({}, this.getDatos(keys, this.objForm.objProducto), { abrirModal: false, idEstado: _.toString(this.parametros.idEstadoDefault) });
                        break;
                    case 5:
                        var keys = ['idProducto', 'idSeguro', 'idVehiCredi'];
                        this.objForm.objProducto = _.merge({}, this.objForm.objProducto, this.listGeneral.listaDatosGenerales);
                        this.objForm.objCondiciones = _.merge({}, this.getDatos(keys, this.objForm.objProducto), { idEstado: _.toString(this.parametros.idEstadoDefault) });
                        this.objForm.objCondiciones = _.merge({}, this.objForm.objCondiciones, { productoCredito: _.get(this.objForm.objCondiciones, 'idVehiCredi', this.objForm .objProducto.idVehiCredi) });

                        if (this.parametros.idSeguroVehiculo != parseInt(this.objForm.objProducto.idSeguro))
                            _.set(this.listGeneral, 'listaAccesorios', []);
                        break;
                    case 6:
                        this.objForm.objCoberturas = {
                            'idProducto': this.objForm.objProducto.idProducto,
                            'idSeguro': !_.isUndefined(this.objForm.objProducto.idVehiCredi) && !_.isNull(this.objForm.objProducto.idVehiCredi) ? this.objForm.objProducto.idVehiCredi : this.listGeneral.listaDatosGenerales.idVehiCredi,
                            'idEstado': _.toString(this.parametros.idEstadoDefault)
                        };
                        break;
                }
            },
            previous() {
                --this.elemento;
            },
            getDatos(keys, obj) {
                var objeto = {};
                // Lo capturado en el paso 1 (listaDatosGenerales) es lo mas reciente; "obj" (objProducto) puede traer
                // el valor original del producto al editar, asi que solo es el respaldo.
                _.forEach(keys, (v) => {
                    _.set(objeto, v, _.get(this.listGeneral.listaDatosGenerales, v, _.get(obj, v, null)));
                })

                return objeto;
            }
        },
        provide() {
            return {
                next: this.next,
                previous: this.previous
            }
        }
    }
</script>

<style>
    .removeBorder {
        box-shadow: none;
    }
</style>